import { applyAbsoluteLinks, removeEmptyWikiSections } from './wiki-links';

export function resolveWikipediaLinks(
  html: string | undefined,
  lang: string | undefined,
): string | undefined {
  if (!html) return html;

  const doc = new DOMParser().parseFromString(html, 'text/html');
  applyAbsoluteLinks(doc, `https://${lang ?? 'en'}.wikipedia.org/wiki/`);
  removeEmptyWikiSections(doc);

  return doc.body.innerHTML;
}

export function extractWikipediaSummary(html: string | undefined): string | undefined {
  if (!html) return html;

  const doc = new DOMParser().parseFromString(html, 'text/html');
  const firstSection = doc.querySelector('section');

  return firstSection ? firstSection.innerHTML : html;
}
